import { locations } from "../../common/redux/action_locations";
import {
	FETCH_PTO_SPOTS,
    PTO_SPOTS_RECIEVED  
  
} from "./constants";
import { CFAuthGetRef } from "auth";



function fetchPTOSpots(filters){
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_AP_API_URL + 
            `/TimeoffRequest/Availability/${filters.managementUnitID}`,     
        params: { 
            startDate: filters.startDate,
            endDate: filters.endDate
         },             
        originURL: process.env.PUBLIC_URL,
        loaderName: ''
    });
}


export function fetchPTOSpotsAction(filters) {
	return {
        type: FETCH_PTO_SPOTS,
        fetchCall: fetchPTOSpots,
        receivedAction: recievedPTOSpotsAction,
        data: {
            filters,
            locations
        }
    };
}


function recievedPTOSpotsAction(data){ 
    var ptoSpots= []  
    // data =  {"2018-09-11T00:00:00":{"allocatedHours":8,"approvedHours":7,"pendingHours":8}}  
    Object.values(data).forEach(item => {   
        let approvedSpots = item.approvedHours > 7 ? item.approvedHours/8 : 0
        let pendingSpots = item.pendingHours > 7 ? item.pendingHours/8 : 0
        let availableSpots = item.allocatedHours < 8 ? 
                            0 : (item.allocatedHours/8) - (approvedSpots + pendingSpots) 

        ptoSpots.push({
                available_spots: availableSpots,
                approved_spots: approvedSpots,
                pending_spots: pendingSpots
            });
    })
    return{
        type:PTO_SPOTS_RECIEVED,
        ptoSpots: ptoSpots
    }
} 


export function reducer(state, action) {
    switch (action.type) {
        case PTO_SPOTS_RECIEVED:
            return {
                ...state,
                ptoSpots: action.ptoSpots
            };        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/timeoff/redux/supervisor_time_off_pending_widget_actions.js